import { Divider, Row } from "antd";
import { BackToButton } from "components/Shared/BackToButton";
import { PageTitle } from "components/Shared/PageTitle";
import { useFetchEntities } from "hooks/useEntitiesApi";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { BaseEntityCard } from "./components/BaseEntityCard";
import { SelectTable } from "./SelectTable";

export const SelectEntityPage: React.FC<any> = () => {
  const { formatMessage } = useIntl();
  const { customerId } = useParams();
  const [searchText, setSearchText] = useState("");
  const { isLoading, data: entitiesResponse } = useFetchEntities();
  const entities = entitiesResponse?.data || [];
  const filteredEntities = entities.filter(
    (x) => x && x.nameFullLocal?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1
  );

  const getCardName = (entity: any) =>
    [
      entity.nameFullLocal ?? "",
      ...(entity.gender ? [formatMessage({ id: `gender.${entity.gender}` })] : []),
      ...(entity.ageGroup ? [formatMessage({ id: `ageGroup.${entity.ageGroup}` })] : []),
    ].join(" | ");

  const getCardDescription = (entity: any) =>
    [
      ...(entity.discipline ? [formatMessage({ id: `discipline.${entity.discipline}` })] : []),
      ...(entity.standard ? [formatMessage({ id: `standard.${entity.standard}` })] : []),
    ].join(" | ");

  return (
    <>
      <Row className="mt-15" justify="space-between">
        <PageTitle isLoading={false} title={formatMessage({ id: "selectEntityPage.title" })} />
        <BackToButton to={`/${customerId}`} btnText={formatMessage({ id: "back.to.organizations" })} />
      </Row>
      <Divider />
      <Row justify="center">
        <SelectTable
          isLoading={isLoading}
          items={filteredEntities}
          onSearch={setSearchText}
          validations={[
            {
              message: formatMessage({ id: "selectEntityPage.noEntities" }),
              check: () => entities.length === 0,
            },
          ]}
          render={(x: any) => (
            <BaseEntityCard
              img={x.imageLogoUrl}
              key={x.entityId}
              to={x.entityId}
              desc={getCardDescription(x)}
              name={getCardName(x)}
            />
          )}
        />
      </Row>
    </>
  );
};
